import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 获取当前系统信息
 * https://app.apifox.com/project/3858755/apis/api-158259432
 * @param name__icontains 根据名称获取信息
 */
const GetSystemMsg = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/ceping/info/home_info/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 上传文件到OSS
 * @param file
 */
const UploadFileToOSS = (vCom: any, params: any, loading?: any, token?: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/authx/filer/", params, {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
        }).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 获取舌象信息算法结果以及deepseek的初步诊断建议
 * https://app.apifox.com/link/project/6001703/apis/api-270020285
 * @param file_url
 */
const GetTongueInfo = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/szr/sizhen/fetch_first_result/", params).then(({ data }) => {
            console.log(666666666)
            resolve(data);
            // resHandle(vCom, data, loading).then(() => {
            //     resolve(data);
            // });
        }).catch(() => {
            console.log(55555)
            resolve('失败');
        });
    });
};
/**
 * @description 获取deepseek的最终报告内容
 * @param algo_result{result_dict:{},result_text:''}
 * @param deepseek_result ''
 * @param extra_text ''
 */
const GetFinalReport = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/szr/sizhen/fetch_final_result/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 语音转文字
 */
const GetAudioText = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/szr/speech/stt/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 文字转语音
 */
const GetTextAudio = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/szr/speech/tts/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading.close()
            reject();
        });
    });
};
/**
 * @description 获取报告二维码
 */
const GetReportQrcode = (vCom: any, path: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`api/szr/sizhen/generate_qrcode/${path}/`, {
            ...params,
            responseType: 'arraybuffer'  // 指定响应类型为 arraybuffer
        }).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description 生成外部系统二维码
 */
const GetExternalReportQrcode = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`/api/szr/sizhen/generate_external_qrcode/`, params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description html转pdf
 */
const HtmlToPdf = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`/report/html_to_pdf`, {
            ...params,
            // responseType: 'arraybuffer'  // 指定响应类型为 arraybuffer
        }).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description 获取报告
 *  
 */
const GetReportData = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`api/szr/report/${path}/`).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description 获取前一次报告
 *  
 */
const GetReportList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/szr/report/search/`, params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description 查询client信息
 * @url https://app.apifox.com/link/project/6001703/apis/api-306844383
 * @param user_id
 */
const GetClientInfo = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/szr/client/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description 创建client
 * @url https://app.apifox.com/link/project/6001703/apis/api-306844382
 * @param user_id
 */
const CreateClient = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/szr/client/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
/**
 * @description 创建匿名用户并自动登录
 * @url https://app.apifox.com/link/project/6001703/apis/api-371726187
 */
const CreateAnonymousClient = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/szr/client/anonymous/").then(({ data }) => {
            resolve(data);
        }).catch(() => {
            loading?.close();
            reject();
        });
    });
};
export {
    GetSystemMsg, UploadFileToOSS, GetTongueInfo, GetFinalReport, GetAudioText,
    GetTextAudio, GetReportQrcode, GetExternalReportQrcode, GetReportData,
    GetClientInfo, CreateClient, GetReportList,
    HtmlToPdf, CreateAnonymousClient
};

